import React from 'react';
import PropTypes from 'prop-types';

import { MCmsCard } from '../../molecules';

export default function OInfoCards({ items }) {
	return (
		<section className="o-cms-card-list">
			{ items.map(item => <MCmsCard key={item.title} {...item} />) }
		</section>
	);
}

OInfoCards.propTypes = {
	items: PropTypes.array.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.info-cards.js